import { TableCell } from "@mui/material";
import { AggregateScoresNode } from "../FirewatchPage";

export const SpaceCell = ({ row }: { row: AggregateScoresNode }) => {
  const entity = row?.entity;
  let display = "";
  if (
    entity?.__typename === "EntityInfoAsset" ||
    entity?.__typename === "EntityInfoSpace"
  ) {
    display = entity.name || entity.id;
  }
  return <TableCell>{display}</TableCell>;
};
